import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const ControListAction = createAsyncThunk("controList",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.controversyList, payload);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

const ControListSlice = createSlice({
    name: "controList",
    initialState: {
        isLoading: false,
        data: false,
        error: null,
        success: false
    },
    reducers: {
        ControListReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false
            };
        },
    },
    extraReducers: {
        [ControListAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [ControListAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [ControListAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const { ControListReset } = ControListSlice.actions
export default ControListSlice.reducer